export const getRegHolder = (base_url, id) => {
  if(base_url.match('services')) {
    return {
      id: id,
      type: 'service'
    }
  } else {
    return {
      id: id,
      type: 'provider'
    }
  }
}

export const urlName = regHolder => (regHolder.type + 's')

export const regHolderBasePath = regHolder => (`/api/${urlName(regHolder)}/${regHolder.id}`)



// WEBPACK FOOTER //
// ./src/reg-holder/index.js